import request from "./clientsApi";
import { API_ROUTES } from "../config/baseURL";

export const apiGetPreguntas = async (idpregunta,idsubgrupo) => {
  const rs = await request(API_ROUTES.getQuestions(idpregunta, idsubgrupo), {
    method: "GET",
  });
  return rs.json();
};

export const apiSavePreguntas = async (form) => {
  const res = await request(API_ROUTES.saveQuestions, {
    method: "POST",
    body: JSON.stringify(form),
  });

  return res.json();
};

export const apiDeletePreguntas = async (id) => {
  const res = await request(API_ROUTES.deleteQuestions, {
    method: "POST",
    body: JSON.stringify({ id }),
  });

  return res.json();
};
